import { useEffect, useRef } from "react";
import "./CustomCursor.css";

function CustomCursor() {
  const circleRef = useRef(null);
  const mousePosRef = useRef({ x: 0, y: 0 });
  const circlePosRef = useRef({ x: 0, y: 0 });
  const animationFrameRef = useRef(null);

  useEffect(() => {
    const updateMousePosition = (e) => {
      mousePosRef.current = { x: e.clientX, y: e.clientY };
    };

    const animate = () => {
      const mouse = mousePosRef.current;
      const circle = circlePosRef.current;
      
      const dx = mouse.x - circle.x;
      const dy = mouse.y - circle.y;
      
      // Slow follow effect (0.15 = 15% speed, creates smooth trailing)
      const speed = 0.15;
      const newX = circle.x + dx * speed;
      const newY = circle.y + dy * speed;
      
      circlePosRef.current = { x: newX, y: newY };
      
      if (circleRef.current) {
        circleRef.current.style.left = `${newX}px`;
        circleRef.current.style.top = `${newY}px`;
      }
      
      animationFrameRef.current = requestAnimationFrame(animate);
    };

    window.addEventListener("mousemove", updateMousePosition);
    animationFrameRef.current = requestAnimationFrame(animate);

    return () => {
      window.removeEventListener("mousemove", updateMousePosition);
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }
    };
  }, []);

  return <div ref={circleRef} className="cursor-circle" />;
}

export default CustomCursor;

